export enum PaymentStatus {
    Pending = 10,
    Authorized = 20,
    PartiallyPaid = 25,
    Paid = 30,
    PartiallyRefunded = 35,
    PendingRefunded = 39,
    Refunded = 40,
    Voided = 50
}